import React from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";

import FlightDirection from "../atoms/FlightDirection";
import FlightTime from "../atoms/FlightTime";

import { greyMinor, white, warning } from "../../../constants/colors";
import StepperIcon from "../../../assets/img/stepper.svg";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  layoverStyles: {
    fontSize: "1.2rem",
    color: greyMinor,
    backgroundColor: white,
    borderRadius: "49px",
    padding: "12px 16px",
    "& span": {
      "&:first-of-type": {
        marginRight: "4px",
      },
    },
  },
  layoverTechnicalStyles: {
    fontSize: "1.2rem",
    borderRadius: "999px",
    padding: "11px 16px",
    backgroundColor: white,
    border: `2px solid ${warning}`,
    color: warning,
    "& span": {
      "&:first-of-type": {
        marginRight: "4px",
      },
    },
  },
  layoverChangeStyles: {
    display: "flex",
    alignItems: "center",
    color: warning,
    "& svg" : {
        marginLeft: "16px",
        marginRight: "4px"
    }
  },
  flightItineraryStyles: {
    width: "100%",
    flexDirection: "column",
  },
  pointStepper: {
    marginRight: "10px",
    "& img": {
      height: "100px",
      [down("xs")]: {
        height: "120px",
      },
    },
  }
}));

const FlightItinerary = ({
  departure,
  arrival,
  duration,
  meal,
  layover,
  carrierInfo,
  airports,
  operatedBy,
}) => {
  const { flightItineraryStyles, layoverStyles, layoverTechnicalStyles, layoverChangeStyles, pointStepper } = useStyles();

  return (
    <Box display="flex" className={flightItineraryStyles}>
      <Box display="flex">
        <Box className={pointStepper}>
          <img src={StepperIcon} alt="stepper" />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <FlightDirection
            time={departure?.time}
            date={departure?.date}
            location={airports[departure.airport]?.city}
            airportAbbr={departure?.airport}
          />
          <FlightTime
            duration={duration}
            meal={meal}
            carrierInfo={carrierInfo}
            operatedBy={operatedBy}
          />
          <FlightDirection
            time={arrival?.time}
            date={arrival?.date}
            location={airports[arrival?.airport]?.city}
            airportAbbr={arrival?.airport}
          />
        </Box>
      </Box>
        {layover && (
            layover.isTechnical ? (
                <Box mt={3} className={layoverTechnicalStyles} display="flex" alignItems="center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" style={{ marginRight : '8px' }}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <Typography variant="caption" color="orange" style={{ lineHeight: '1.3' }}>
                        <b>{layover?.duration}</b> <b>Technical stop</b> &nbsp; | &nbsp; <span style={{ fontSize: '11px' }}> May include a change of airplane </span>
                    </Typography>
                </Box>
            ) : (
                <Box mt={3} className={layoverStyles} display="flex" alignItems="center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" style={{ marginRight : '8px' }}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <Typography variant="caption" color="textSecondary">
                        <b>{layover?.duration}</b>
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        {`layover in ${airports[layover?.airport]?.city}`}
                    </Typography>
                    {layover.isAirportChange && (
                        <Typography className={layoverChangeStyles} variant="caption">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                            <b>Airport Change</b>
                        </Typography>
                    )}
                </Box>
            )
        )}
    </Box>
  );
};

export default FlightItinerary;
